export default __webpack_public_path__ + "static/media/taken.3ff56416.svg";